import { Routes } from '@angular/router';
import {
  centralOnlyCanActivate,
  centralOnlyCanMatch,
  selfManagementCanActivate,
  selfManagementCanMatch,
  tenantOnlyCanActivate,
  tenantOnlyCanMatch,
} from '@core/guards';
import { AppLayout } from '@core/diamond/components/app.layout';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/core.routes').then((module) => module.routes),
  },
  {
    path: 'central',
    component: AppLayout,
    canMatch: [centralOnlyCanMatch],
    canActivate: [centralOnlyCanActivate],
    loadChildren: () => import('./features/central/central.routes').then((module) => module.routes),
  },
  {
    path: 'customer',
    component: AppLayout,
    canMatch: [tenantOnlyCanMatch],
    canActivate: [tenantOnlyCanActivate],
    loadChildren: () => import('./features/tenant/tenant.routes').then((module) => module.routes),
  },
  {
    path: 'subscription',
    loadChildren: () => import('./features/paddle/paddle.routes').then((module) => module.routes),
  },
  {
    path: 'signup',
    loadChildren: () => import('./features/signup/signup.routes').then((module) => module.routes),
  },
  {
    path: 'employee',
    component: AppLayout,
    canMatch: [selfManagementCanMatch],
    canActivate: [selfManagementCanActivate],
    loadChildren: () =>
      import('./features/self-management/self-management.routes').then((module) => module.routes),
  },
  { path: '**', redirectTo: '/login' },
];
